var render = function render(_c,_vm){return _c('div',{staticClass:"scrollLoader"},[(_vm.props.isActive)?_c('div',{staticClass:"scrollLoader_wrapper"},[_c('div',{staticClass:"scrollLoader-dot__1"}),_c('div',{staticClass:"scrollLoader-dot__2"}),_c('div',{staticClass:"scrollLoader-dot__3"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }